import type { RFQApp } from 'apps/rfq/app';
import { addDays } from 'date-fns';
import { JobSpecApp } from 'apps/rfq/app';
import { ProductQuoteApp } from './app';

export const productQuoteFromRFQ = (
  parent: any,
  rfq: RFQApp,
  shipmentQuoteAppManager: any,
) => {
  const productQuoteApp = new ProductQuoteApp(parent, {
    // for: forJobSpec,
    from: rfq,
    cost: '',
    currency: shipmentQuoteAppManager?.shipmentQuoteApp.currency,
    supplier: shipmentQuoteAppManager?.shipmentQuoteApp.manufacturer,
    validUntil: addDays(new Date(), 30), // take from ShipmentQuoteApp expiry date
  });
  const forJobSpec = rfq.jobSpec.toJs(undefined, true);
  // const forJobSpec = rfq.jobSpec;
  const forJobSpecApp = new JobSpecApp(productQuoteApp, forJobSpec);
  productQuoteApp.for = forJobSpecApp;
  return productQuoteApp;
};
